import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaClipboardList, FaMoneyCheckAlt, FaShippingFast } from "react-icons/fa";
import styles from "./CapsuleTabs.module.css";
import type { RootState } from "../Services/Store";

const CapsuleTabs: React.FC = () => {
  const navigate = useNavigate();
  const { orderId, id } = useParams();
  const location = useLocation();
  const path = location.pathname;

  // Get the user role from Redux (works for both Admin/Employee and Customer)
  const userRole = useSelector((state: RootState) => state.auth.user?.role_name?.toLowerCase());


  const realOrderId = orderId || id;


  const isCustomer = userRole === "customer";
  const basePath = isCustomer ? `/mysaleorder-management/${realOrderId}` : `/saleorder/${realOrderId}`;

  return (
    <div className={styles.capsuleTabs}>
      <button
        className={
          path === basePath ||
          path === `${basePath}/` ||
          (!path.includes("order-details") && !path.includes("track-payment") && !path.includes("track-orders"))
            ? styles.active
            : styles.tabBtn
        }
        onClick={() => navigate(basePath)}
      >
        <FaClipboardList /> Details
      </button>
      {/* <button
        className={path.includes("order-details") ? styles.active : styles.tabBtn}
        onClick={() => navigate(`${basePath}/order-details`)}
      >
        <FaClipboardList /> Order Details
      </button> */}
      <button
        className={path.includes("track-payment") ? styles.active : styles.tabBtn}
        onClick={() => navigate(`${basePath}/track-payment`)}
      >
        <FaMoneyCheckAlt /> Track Payment
      </button>
      <button
        className={path.includes("track-orders") ? styles.active : styles.tabBtn}
        onClick={() => navigate(`${basePath}/track-orders`)}
      >
        <FaShippingFast /> Track Orders
      </button>
    </div>
  );
};

export default CapsuleTabs;
